import { isDev } from '@config/configConstants';
import storage from '@utils/storage';
import { useEffect, useState } from 'react';

export const ALLOWED_USER_IDS = new Set<string>(['2', '3', '723', '152412']);

export function hasPreviewAccess(userId: string | null = storage.getUserId()) {
  if (isDev) {
    return true;
  }
  return Boolean(userId && ALLOWED_USER_IDS.has(userId));
}

export function usePreviewAccess() {
  const [allowed, setAllowed] = useState(() => hasPreviewAccess());

  useEffect(() => {
    setAllowed(hasPreviewAccess(storage.getUserId()));
  }, []);

  return allowed;
}

// Whether someone with preview access shows testing-only tools (e.g. Auto-plan's typed instructions). Switched off to
// see a feature exactly as a student will; remembered in this browser.
const TESTING_TOOLS_KEY = 'testingTools';
export const showsTestingTools = () => localStorage.getItem(TESTING_TOOLS_KEY) !== 'off';
export const setShowsTestingTools = (show: boolean) =>
  show ? localStorage.removeItem(TESTING_TOOLS_KEY) : localStorage.setItem(TESTING_TOOLS_KEY, 'off');
